import axios from "axios";
import "@/plugins/datetime";

const state = {
  managers: [],
  operators: [],
  patients: [],
  queuedPatients: [],
  currentUser: {},
};

const actions = {
  getAllUser: (context, role) => {
    let resource = "patients";

    if (role == "manager") {
      resource = "managers";
    } else if (role == "operator") {
      resource = "operators";
    }

    return new Promise((resolve, reject) => {
      axios({
        method: "GET",
        url: context.rootGetters.baseUrl + resource,
      })
        .then((response) => {
          const users = response.data.data;
          context.commit("USERS_UPDATE", { users, role });
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getQueuedPatients: (context, date) => {
    return new Promise((resolve, reject) => {
      axios({
        method: "GET",
        url: context.rootGetters.baseUrl + "patients/queued/" + date,
      })
        .then((response) => {
          const users = response.data.data;
          context.commit("QUEUED_PATIENTS_UPDATE", users);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getUser: (context, id) => {
    return new Promise((resolve, reject) => {
      axios({
        method: "GET",
        url: context.rootGetters.baseUrl + "patients/" + id,
      })
        .then((response) => {
          const user = response.data.data;
          context.commit("CURRENT_USER_UPDATE", user);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  addUser: (context, payload) => {
    let resource = "patients";

    if (payload.role == "manager") {
      resource = "managers";
    } else if (payload.role == "operator") {
      resource = "operators";
    }

    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        url: context.rootGetters.baseUrl + resource,
        data: {
          first_visit_date: LuxonDateTime.fromISO(
            payload.firstVisitDate
          ).toFormat("yyyy-LL-dd"),
          id_card_number: payload.idCardNumber,
          fullname: payload.fullname,
          date_of_birth: LuxonDateTime.fromFormat(
            payload.dateOfBirth,
            "dd/LL/yyyy"
          ).toFormat("yyyy-LL-dd"),
          gender: payload.gender,
          religion: payload.religion,
          education: payload.education,
          profession: payload.profession,
          address: payload.address,
          marital_status: payload.maritalStatus,
          blood_type: payload.bloodType,
          department_id: payload.departmentId,
          email: payload.email,
          phone: payload.phone,
        },
      })
        .then((response) => {
          const user = response.data.data;
          const role = payload.role;
          context.commit("USER_ADD", { user, role });
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateUser: (context, payload) => {
    const userId = payload.id;
    return new Promise((resolve, reject) => {
      axios({
        method: "PUT",
        url: context.rootGetters.baseUrl + "patients/" + userId,
        data: {
          first_visit_date: LuxonDateTime.fromISO(
            payload.first_visit_date
          ).toFormat("yyyy-LL-dd"),
          id_card_number: payload.id_card_number,
          fullname: payload.fullname,
          date_of_birth: payload.date_of_birth,
          gender: payload.gender,
          religion: payload.religion,
          education: payload.education,
          profession: payload.profession,
          address: payload.address,
          marital_status: payload.marital_status,
          blood_type: payload.blood_type,
          department_id: payload.department_id,
          phone: payload.phone,
        },
      })
        .then((response) => {
          const user = response.data.data;
          context.commit("CURRENT_USER_UPDATE", user);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

const mutations = {
  USERS_UPDATE: (state, { users, role }) => {
    if (role == "manager") {
      state.managers = users;
    } else if (role == "operator") {
      state.operators = users;
    } else if (role == "patient") {
      state.patients = users;
    }
  },
  USER_ADD: (state, { user, role }) => {
    if (role == "manager") {
      state.managers.push(user);
    } else if (role == "operator") {
      state.operators.push(user);
    } else if (role == "patient") {
      state.patients.push(user);
    }
  },
  CURRENT_USER_UPDATE: (state, user) => {
    state.currentUser = user;
  },
  QUEUED_PATIENTS_UPDATE: (state, users) => {
    state.queuedPatients = users;
  },
};

const getters = {
  managers: (state) => state.managers,
  operators: (state) => state.operators,
  patients: (state) => state.patients,
  currentUser: (state) => state.currentUser,
  queuedPatients: (state) => state.queuedPatients,
};

export default {
  state: state,
  getters,
  actions,
  mutations,
};
